module.exports = __webpack_public_path__ + "static/media/linkedin.6976c96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/linkedin.png
// module id = 79
// module chunks = 0